<script setup lang="ts">
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import { AccessPageMeta } from '@/access/accessPageMeta'
import GoogleOAuthConnectionCard from '@/views/setup/google-oauth/GoogleOAuthConnectionCard.vue'

definePage({ meta: AccessPageMeta.GoogleConnection.Meta })
setPageTitle(AccessPageMeta.GoogleConnection.Title)
</script>

<template>
  <VRow data-testid="google-connection-page">
    <VCol cols="12">
      <GoogleOAuthConnectionCard />
    </VCol>
  </VRow>
</template>
